<sidebar-cmp  *ngIf="_appService?.CoreCommonLiterals && !hideNav"></sidebar-cmp>
<section class="main-container" *ngIf="_appService?.CoreCommonLiterals" [ngClass]="{'m-0': hideNav, 'p-0': sharedAssets}">
  <top-nav *ngIf="_showTopNav && (_loginPage===false) && !hideNav"
    (onNotificationSelected)="onNotificationSelected($event)"
    (onNotificationsSeeAll)="onNotificationsSeeAll()"></top-nav>
  <ng-template #topNavDirective></ng-template>
  <div class="maintenance-banner" *ngIf="(_appService.facilityOperationalStatus | async) === maintenanceStatus && !hideNav && !_loginPage">
    <i class="fas fa-wrench mr-2"></i>
    <span>{{ _appService.CoreCommonLiterals?.Maintenance || 'Maintenance Mode' }} — {{ _appService.CoreCommonLiterals?.MaintenanceBannerMessage || 'This facility is in maintenance mode. New alarms and actions are suspended.' }}</span>
  </div>
  <loading-full-screen *ngIf="_appService.LOADING"></loading-full-screen>
  <toaster-container [toasterconfig]="_appService.getToasterConfig()"></toaster-container>
  <router-outlet></router-outlet>
  <router-outlet name="modal"></router-outlet>
</section>
<modal-welcome *ngIf="_appService.CoreCommonLiterals"></modal-welcome>
<modal-terms-conditions *ngIf="_appService.CoreCommonLiterals"></modal-terms-conditions>